import { useTheme } from "@mui/material/styles";

const VehicleTypeIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="26"
        height="26"
        rx="4"
        fill={theme.palette.otherDivider.main}
      />
      <path
        d="M18.8334 11.3333V8.16667C18.8334 7.23325 18.8334 6.76654 18.6518 6.41002C18.492 6.09641 18.237 5.84144 17.9234 5.68166C17.5669 5.5 17.1002 5.5 16.1667 5.5H9.83341C8.89999 5.5 8.43328 5.5 8.07676 5.68166C7.76316 5.84144 7.50819 6.09641 7.3484 6.41002C7.16675 6.76654 7.16675 7.23325 7.16675 8.16667V11.3333M7.16675 10.5H4.66675V9.66667M18.8334 10.5H21.3334V9.66667M8.00008 14.25H8.00841M18.0001 14.25H18.0084M8.66675 11.3333H17.3334C18.7335 11.3333 19.4336 11.3333 19.9684 11.6058C20.4388 11.8455 20.8212 12.228 21.0609 12.6984C21.3334 13.2331 21.3334 13.9332 21.3334 15.3333V18C21.3334 18.7766 21.3334 19.1649 21.2065 19.4711C21.0374 19.8795 20.7129 20.204 20.3046 20.3731C19.9983 20.5 19.61 20.5 18.8334 20.5H18.3334C18.0237 20.5 17.8689 20.5 17.7394 20.4795C17.0262 20.3665 16.4669 19.8072 16.3539 19.0941C16.3334 18.9645 16.3334 18.8097 16.3334 18.5C16.3334 18.4226 16.3334 18.3839 16.3283 18.3515C16.3 18.1732 16.1602 18.0334 15.9819 18.0051C15.9495 18 15.9108 18 15.8334 18H10.1667C10.0893 18 10.0506 18 10.0182 18.0051C9.83995 18.0334 9.70012 18.1732 9.67188 18.3515C9.66675 18.3839 9.66675 18.4226 9.66675 18.5C9.66675 18.8097 9.66675 18.9645 9.64623 19.0941C9.53328 19.8072 8.97396 20.3665 8.26081 20.4795C8.13125 20.5 7.97642 20.5 7.66675 20.5H7.16675C6.39018 20.5 6.00189 20.5 5.69561 20.3731C5.28723 20.204 4.96277 19.8795 4.79362 19.4711C4.66675 19.1649 4.66675 18.7766 4.66675 18V15.3333C4.66675 13.9332 4.66675 13.2331 4.93923 12.6984C5.17892 12.228 5.56137 11.8455 6.03177 11.6058C6.56655 11.3333 7.26662 11.3333 8.66675 11.3333ZM8.41675 14.25C8.41675 14.4801 8.2302 14.6667 8.00008 14.6667C7.76996 14.6667 7.58341 14.4801 7.58341 14.25C7.58341 14.0199 7.76996 13.8333 8.00008 13.8333C8.2302 13.8333 8.41675 14.0199 8.41675 14.25ZM18.4167 14.25C18.4167 14.4801 18.2302 14.6667 18.0001 14.6667C17.77 14.6667 17.5834 14.4801 17.5834 14.25C17.5834 14.0199 17.77 13.8333 18.0001 13.8333C18.2302 13.8333 18.4167 14.0199 18.4167 14.25Z"
        stroke={theme.palette.text.secondary}
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VehicleTypeIcon;
